<div class="nuaxia-popup">

</div>
<div class="text-center">
  <mat-icon [svgIcon]="data.icon" style="height:150px;width:150px;"></mat-icon>
</div>
<h2 class="nuaxia-popup-title" mat-dialog-title>{{data.title}}</h2>
<button mat-flat-button class="fuse-mat-button-large w-full mt-6" type="button" (click)="updateApplication()" [color]="'primary'">Update</button>
